'use strict';

var template  = require('../templates/PersonalSettings.ejs');
var PanelView = require('commons/views/PersonalSettingsPanel');

module.exports = PanelView.extend({
    initialize: function(options) {
        this.options = _.defaults(options || {}, {template: template});
        return PanelView.prototype.initialize.apply(this, [this.options]);
    }
});



// WEBPACK FOOTER //
// ./app/employee/views/PersonalSettings.js